import React from 'react';
import BasePeriodSelector from './BasePeriodSelector/BasePeriodSelector';
import * as Utils from 'utils/utils'
import * as utilsLogic from 'utils/utilsLogic'
import { SelectionProps } from 'types/PeriodSelectionTypes'
import { SelectionTypeEnum } from 'enums/enums';
import Const from 'const.json';

const YearSelection: React.FC<SelectionProps> = (SelectionProps) => {

  const years = getYearsUntil2021();

  const renderYearButtonContent = (year: number) => <div className='yearlyPeriod'>{year}</div>;

  const handleSelectionChange = utilsLogic.SelectionChangeHandler(SelectionTypeEnum.Yearly, SelectionProps);

  return (
    <BasePeriodSelector
      selectionMode='single'
      periods={years}
      renderButtonContent={renderYearButtonContent}
      selectionLabel={Const.yearSelection}
      defaultPeriodIndex={Utils.currentYear}
      onSelectionChange={handleSelectionChange}
      indexes={SelectionProps.indexes}
    />
  );
};

export default YearSelection;

const getYearsUntil2021 = (): number[] => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 4;
  const years: number[] = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  return years;
};

